import { useMutation } from '@tanstack/react-query';

import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

interface GenerateNegotiationResearchRequest {
  community_id: number;
  query?: string;
  negotiation_id?: number;
}

interface GenerateNegotiationResearchResponse {
  response: string;
}

export const useGenerateNegotiationResearch = () => {
  const { session } = useAuth();

  return useMutation<GenerateNegotiationResearchResponse, Error, 
    GenerateNegotiationResearchRequest>({
      mutationFn: async (data: GenerateNegotiationResearchRequest) => {
        const endpoint = 'negotiation/research';
        const requestBody = {
          community_id: data.community_id,
          ...(data.query && { query: data.query }),
          ...(data.negotiation_id && { negotiation_id: data.negotiation_id }),
        };

        const response = await handleApiCall<
        GenerateNegotiationResearchResponse,
        { community_id: number; query?: string; negotiation_id?: number }
      >(session, 'POST', endpoint, requestBody);
        return response;
      },
    });
};